import React from 'react';
import StructuredContent from '@nerdwallet/structured-content';
import {
  useAnalyticsPageView,
  useSegmentAnalytics,
} from '@nerdwallet/seo-analytics';
import { AnalyticsContextProvider } from '@nerdwallet/structured-content/contexts/AnalyticsContext';

export const MarketplaceRateTable = ({
  featuredTabName,
}: {
  featuredTabName?:
    | 'Best Mortgage Lenders'
    | 'First-time Buyer'
    | 'Refinance'
    | 'HELOC'
    | 'Home Equity Loans';
}): JSX.Element => {
  const document = {
    type: 'Document',
    version: '1.0.0',
    props: {
      children: [
        {
          type: 'Container',
          version: '1.0.0',
          props: {
            spacing: {
              bottom: 0,
            },
            children: [
              {
                type: 'MarketplaceRateTable',
                version: '1.0.0',
                props: {
                  productType: 'mortgages',
                  subCategory: 'mortgage_marketplace_named_queries',
                  featuredTabName,
                  showAdvertiserWrapper: true,
                },
              },
            ],
          },
        },
      ],
    },
  };

  const { pageViewId, pageViewReady, pageName } = useAnalyticsPageView();
  const segmentInstance = useSegmentAnalytics();

  const analytics = {
    segmentAttributes: {
      driverPageName: pageName,
      pageViewId,
      pageViewReady,
      segmentInstance: segmentInstance.analytics,
    },
  };

  return (
    <AnalyticsContextProvider value={analytics}>
      <StructuredContent>{document}</StructuredContent>
    </AnalyticsContextProvider>
  );
};
